import { Box, Flex, Text } from '@chakra-ui/react';
import { useShoppingCart } from 'context/shoppingCartContext';
import { FormattedMessage } from 'react-intl';

export const OrderOnBehalfBar = () => {
    const { currentBasket } = useShoppingCart();

    return (
        <>
            {currentBasket && currentBasket.summary && currentBasket.summary.onBehalfBy && (<Flex
                width="half"
                float="left"
                bgColor="blue.300"
                color="white"
                textAlign="center"
                px={4}
                py={2}
                justifyContent="center"
                alignItems="center"
            >
                <Box>
                    <Text>
                        <FormattedMessage id="order.on-behalf.info" /> {currentBasket.summary.fullName}
                    </Text>
                </Box>
            </Flex>)}
        </>
    );
};
